(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/play/play.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/play/play.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.Play = Marionette.View.extend({
    $window: undefined,

    template: function(data) {
      return svs.bingo.templates.bingoclient(data);
    },
    gamePicker: null,
    gamePickerContainer: null,
    headerHeight: 44,
    behaviors: [
      {
        behaviorClass: svs.bingo.behaviors.UpdateCollection,
        resetView: 'resetView'
      }
    ],
    regions: {
      gamePickerRegion: '.js-bingo-gamepicker'
    },
    ui: {
      clientContainer: '#nyxclient',
      gamePickerContainer: '.js-bingo-gamepicker'
    },

    initialize: function() {
      this.$window = $(window);
      this.headerHeight = $('.header-content').outerHeight();
    },

    onAttach: function() {
      var self = this;

      svs.bingo.nyxChannel.request('initBingoClient', {
        gameId: this.model.get('gameId')
      });
      svs.bingo.nyxChannel.reply('attachBingoCallback', function() {
        if (window.nyxbingoclient) {
          window.nyxbingoclient
            .getPortalIntegration()
            .listener(self.model.bingoClientCallback.bind(self.model));
        }
      });

      if (
        !svs.core.detect.formfactor.mobile() &&
        window.navigator.userAgent.match(/ipad|android/i)
      ) {
        $(window).resize(this.resizeClientContainer.bind(this));
      }

      if (!svs.core.detect.formfactor.mobile()) {
        this.gamePicker = new svs.bingo.views.GamePicker({
          collection: this.model.get('activeGames'),
          gameId: self.model.get('gameId')
        });

        this.showChildView('gamePickerRegion', this.gamePicker);

        $('.js-bingo-toggle-gamepicker').on('click', this.toggleGamePickerMenu.bind(this));
        $('.js-bingo-hide-gamepicker').on('click', this.hideGamePickerMenu.bind(this));

        this.triggerMethod('resetView');

        if (this.$window.width() >= 1700) {
          this.showGamePickerMenu();
        }
      }
    },

    onResetView: function() {
      this.triggerMethod('setUpdateTimeout', this.model.get('activeGames'));
      this.triggerMethod(
        'setClosingInterval',
        this.model.get('activeGames').models
      );
    },

    resizeClientContainer: function() {
      var w = this.$window.width(),
        h = this.$window.height() - this.headerHeight;

      this.ui.clientContainer.width(w);
      this.ui.clientContainer.height(h);
    },

    toggleGamePickerMenu: function() {
      if (this.ui.gamePickerContainer.hasClass('hide-menu')) {
        this.showGamePickerMenu();
      } else {
        this.hideGamePickerMenu();
      }
    },

    showGamePickerMenu: function() {
      if (this.ui.gamePickerContainer && this.gamePicker) {
        this.ui.gamePickerContainer.removeClass('hide-menu');
        this.gamePicker.render();
        this.triggerMethod('togglePolling', false);
        this.gamePicker.triggerMethod('setPreventUpdate', false);
      }
    },

    hideGamePickerMenu: function() {
      if (this.ui.gamePickerContainer && this.gamePicker) {
        this.ui.gamePickerContainer.addClass('hide-menu');
        this.triggerMethod('togglePolling', true);
        this.gamePicker.triggerMethod('setPreventUpdate', true);
      }
    },

    onDestroy: function() {
      svs.bingo.nyxChannel.request('destroyClient', this.options);
      window.nyxbingoclient
        .getPortalIntegration()
        .listener(this.model.bingoClientCallback.unbind(this.model));
    }
  });
})(Backbone, _, svs);


 })(window);